import {
  initialState,
  Actions,
  State,
  UPDATE_CURRENT_CUSTOMER,
  UPDATE_CURRENT_CUSTOMER_SUCCESS,
  UPDATE_CURRENT_CUSTOMER_ERROR,
  RESET_UPDATE_CURRENT_CUSTOMER,
} from '../../types/customer/update-current-customer'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case UPDATE_CURRENT_CUSTOMER:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case UPDATE_CURRENT_CUSTOMER_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case UPDATE_CURRENT_CUSTOMER_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_UPDATE_CURRENT_CUSTOMER:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
